<template>
    <div>
        <v-card>
            <v-card-title>
                Live Rate Settings
            </v-card-title>
            <v-card-text>
                <div v-if="integrationId">

                    <v-progress-linear
                        v-if="isLoading"
                        indeterminate
                        color="primary"
                        class="mb-5">
                    </v-progress-linear>
                    <v-tabs
                        background-color="white"
                        color="dark"
                        show-arrows="mobile"
                        v-model="tabSettings">
                        <v-tab href="#tab-qoute">Quote Settings</v-tab>
                        <v-tab href="#tab-fallback">Fallback</v-tab>
                        <v-tab-item value="tab-qoute">
                            <QouteSettings :id="integrationId" />
                        </v-tab-item>
                        <v-tab-item value="tab-fallback">
                            <FallbackSettings :id="integrationId" />
                        </v-tab-item>
                    </v-tabs>

                </div>

            </v-card-text>
        </v-card>
    </div>
</template>
<script>

import QouteSettings from './settings/qoute-settings';
import FallbackSettings from './settings/fallback-settings';
import { mapGetters, mapActions } from "vuex"

export default {

    props: {
        id: { type: Number, default: null },
    },

    components: {
        QouteSettings,
        FallbackSettings
    },

    computed: {

        integrationId() {
            return this.id
        }

    },

    data() {
        return {
            tabSettings: 'tab-qoute',
            isLoading: false,
        }
    },

    mounted() {
        this.onGetSettings()
    },

    methods: {
        onGetSettings() {

            if (!this.integrationId) {
                return
            }

            let params = { integration_id: this.integrationId }
            this.isLoading = true;
            this.$http
                .get('/api/live-rates/settings/quote', { params })
                .then(({ data }) => {
                    if (data.id) {
                        this.setQouteForm(data)
                    } else {
                        this.resetQouteForm()
                    }
                    this.isLoading = false;
                })
                .catch(err => {
                    console.log("[QOUTE_SETTINGS][GET] error: ", err)
                })

            this.$http
                .get('/api/live-rates/settings/box', { params })
                .then(({ data }) => {
                    if (data.id) {
                        this.setBoxForm(data)
                    } else {
                        this.resetBoxForm()
                    }
                    this.isLoading = false;
                })
                .catch(err => {
                    console.log("[QOUTE_SETTINGS][GET] error: ", err)
                })
        },

        ...mapActions('LRSettingsState', [
            'setQouteForm',
            'setBoxForm',
            'resetQouteForm',
            'resetBoxForm'
        ])
    }
}
</script>
